<template>
  <label
    class="sg-radio-button"
    :class="[
      size ? 'sg-radio-button--' + size : '',
      {
        'is-active': modelValue === label,
        'is-disabled': disabled,
        'is-focus': focus,
      },
    ]"
    role="radio"
    :aria-checked="modelValue === label"
    :aria-disabled="disabled"
    :tabindex="tabIndex"
    @keydown.space.stop.prevent="modelValue = disabled ? modelValue : label"
    @click.prevent="changeValue"
  >
    <input
      ref="radioRef"
      v-model="modelValue"
      class="sg-radio-button__original-radio"
      :value="label"
      type="radio"
      v-bind="attrs"
      :disabled="disabled"
      tabindex="-1"
      @focus="focus = true"
      @blur="focus = false"
      @change="handleChange"
    />
    <span
      class="sg-radio-button__inner"
      @keydown.stop
    >
      <slot>
        {{ label }}
      </slot>
    </span>
  </label>
</template>
<script lang="ts">
import { defineComponent, nextTick } from 'vue'
import { useRadio } from './radio'
import { isPromise } from '@vue/shared'
import { isBool } from '@sgui-plus/utils/util'
import { radioButtonProps, radioButtonEmits } from './radio-button'
import { throwError, debugWarn } from '@sgui-plus/utils/error'
export default defineComponent({
  name: 'SgRadioButton',
  props: radioButtonProps,
  emits: radioButtonEmits,
  setup(props, { emit, attrs }) {
    const {
      radioRef,
      isGroup,
      focus,
      size,
      disabled,
      tabIndex,
      modelValue,
      beforeChange
    } = useRadio(props, emit)
    const changeValue = () => {
      if(disabled.value) return
      if(props.label === modelValue.value) return

      if (!beforeChange) {
        modelValue.value = props.label
        handleChange()
        return
      }

      const shouldChange = beforeChange()
      const isExpectType = [isPromise(shouldChange), isBool(shouldChange)].some(
        (i) => i
      )
      if (!isExpectType) {
        throwError(
          'SgRadio',
          'beforeChange must return type `Promise<boolean>` or `boolean`'
        )
      }

      if (isPromise(shouldChange)) {
        shouldChange
          .then((result) => {
            if (result) {
              modelValue.value = props.label
              handleChange()
            }
          })
          .catch((e) => {
            debugWarn('SgRadio', `some error occurred: ${e}`)
          })
      } else if (shouldChange) {
        modelValue.value = props.label
        handleChange()
      }
    }

    function handleChange() {
      nextTick(() => emit('onChange', modelValue.value))
    }

    return {
      attrs,
      isGroup,
      size,
      disabled,
      tabIndex,
      modelValue,
      focus,
      radioRef,
      changeValue,
      handleChange
    }
  },
})
</script>
